import { GraviButton, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import React, { useMemo } from 'react'
import { Tooltip } from 'antd'

export const AssignCardsModalFooter = ({
  isReloading,
  handleCloseAssignModal,
  handleBulkAdd,
  selectedDrivers,
  selectedCards,
}) => {
  const canSave = useMemo(
    () => selectedDrivers?.length && selectedCards?.length,
    [selectedDrivers?.length, selectedCards?.length]
  )

  return (
    <Horizontal className={'p-1'} verticalCenter>
      <Vertical flex={1}>
        <Texto
          appearance={'secondary'}
          textTransform={'uppercase'}
          className={'square-ish'}
          style={!selectedDrivers?.length && { visibility: 'hidden' }}
        >
          {selectedDrivers.length} {selectedDrivers?.length > 1 ? 'Drivers' : 'Driver'} Selected
        </Texto>
      </Vertical>
      <Horizontal flex={1} justifyContent={'end'}>
        <>
          <GraviButton
            buttonText={'Cancel'}
            disabled={isReloading}
            onClick={handleCloseAssignModal}
            className={'square-ish mr-4'}
          />
          <Tooltip title={canSave ? '' : 'Please select at least one driver and one card'} placement={'top'}>
            <GraviButton
              buttonText={'Confirm'}
              loading={isReloading}
              theme1
              className={`square-ish ${canSave ? '' : 'assign-cards-footer-disabled-confirm-button'}`}
              onClick={canSave ? handleBulkAdd : () => {}}
            />
          </Tooltip>
        </>
      </Horizontal>
    </Horizontal>
  )
}
